
// src/connects/group-member-icons.js

import { connect } from 'react-redux'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import lifecycle from '../helpers/lifecycle'
import { translate } from 'react-i18next'
import ui from '../helpers/ui-state'

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willUpdate: (props, nextProps)=> {
      if (props.ui.is_details != nextProps.ui.is_details && !nextProps.ui.is_details) {
        if (nextProps.ui.is_pc && nextProps.ui.show_summary) {
          nextProps.updateUI({ is_summary: true, is_pc: false, show_summary: false })
        }
      }
    },
    openMembersPage: ()=> dispatch(actions.openRightSidePage('group_members', { group_id: ownProps.group.group_id })),
    showUserTimeline: (group_id, user)=> dispatch(actions.openRightSidePage('user_timeline', { group_id: group_id, user_id: user.user_id, user: user })),
  }
}

export default combineHOC(
  connect(undefined, mapDispatchToProps),
  ui({ 
    state: { 
      showAll: false,
      is_details: false,
      is_summary: false,
      user: undefined,
      is_pc: false,
      show_summary: false,
    }}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/group-member-icons.js